// extracted by mini-css-extract-plugin
export default {"title":"social-shelf-items-AbbreviatedTitle__title--2ALJs"};